/* RESPONSIBLE TEAM: team-ai-insights */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class OptimizeFinReasonsRoute extends Route {
  @service declare appService: AppService;
  @service declare router: RouterService;

  routeWhenNotOptedIn = 'apps.app.automation.fin-ai-agent.analyze.ai-insights';

  async beforeModel() {
    if (!this.appService.app.canSeeOptimize) {
      this.router.transitionTo(this.routeWhenNotOptedIn);
      return;
    }
    this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.optimize-suggestions');
  }
}
